export default __webpack_public_path__ + "c026bb7477db9ef6e6de2b847d45db17.svg";